<script setup lang="ts">
import { computed, inject, type Ref } from 'vue';
import { useField } from 'vee-validate';
import type { Locales } from '@/services/types/api.types';

const props = defineProps<{
  name: string;
}>();

const nameFr = computed(() => `${props.name}.fr`);
const nameEn = computed(() => `${props.name}.en`);
const { value: valueFr, errorMessage: errorMessageFr } = useField<string | null>(nameFr.value);
const { value: valueEn, errorMessage: errorMessageEn } = useField<string | null>(nameEn.value);
const editLocale = inject<Ref<Locales>>('editLocale');
const removeImage = async (lang: string, index: number) => {
  const content = lang === 'fr' ? valueFr : valueEn;
  content.value.splice(index, 1);
};
</script>

<template>
  <div v-show="valueFr.length > 0 || valueEn.length > 0">
    <div v-if="editLocale === 'fr'" class="image-list">
      <div v-for="(item, index) in valueFr" :key="index" class="col-3">
        <div class="card-wrapper">
          <div class="image">
            <q-img
              :src="item.url"
              spinner-color="primary"
              spinner-size="82px"
              style="height: 170px; max-width: 140px"
              class="uploaded-image"
            />
            <q-btn size="xs" round flat>
              <q-tooltip>
                {{ $t('context.removeFile') }}
              </q-tooltip>
              <q-icon @click="removeImage(editLocale, index)" color="white" name="close" />
            </q-btn>
          </div>
          <div class="name">
            <q-tooltip>
              {{ item.name }}
            </q-tooltip>
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- <q-input
                :model-value="JSON.stringify(valueFr)"
                type="hidden"
            /> -->
    </div>
    <div v-else-if="editLocale === 'en'" class="image-list">
      <div v-for="(item, index) in valueEn" :key="index" class="col-3">
        <div class="card-wrapper">
          <div class="image">
            <q-img
              :src="item.url"
              spinner-color="primary"
              spinner-size="82px"
              style="height: 170px; max-width: 140px"
              class="uploaded-image"
            />
            <q-btn size="xs" round flat>
              <q-tooltip>
                {{ $t('context.removeFile') }}
              </q-tooltip>
              <q-icon @click="removeImage(editLocale, index)" color="white" name="close" />
            </q-btn>
          </div>
          <div class="name">
            <q-tooltip>
              {{ item.name }}
            </q-tooltip>
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- <q-input
                :model-value="JSON.stringify(valueEn)"
                type="hidden"
            /> -->
    </div>
    <q-banner class="text-white bg-red q-mb-sm" v-if="!editLocale">Missing editLocale injection</q-banner>
  </div>
</template>
<style lang="scss">
.image-list {
  display: flex;
  flex-direction: row;
  background-color: $color-neutral-grey-200;
  padding: 5px;
  border-radius: 8px;

  .card-wrapper {
    width: 170px;

    .image {
      display: flex;
      position: relative;
      justify-content: center;

      .uploaded-image {
        display: flex;
        border: 1px;
        margin: 10px;
        border-radius: 10px;
      }

      .q-btn {
        position: absolute;
        top: 0px;
        right: 8px;
        z-index: 2;
        padding: 2px;
        background-color: $color-neutral-grey-400-50;
        cursor: pointer;

        .q-icon {
          font-size: $header;
        }
      }
    }

    .name {
      max-width: 80%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0 10px;
      font-size: 14px;
    }
  }
}
</style>
